import * as React from 'react';
import NavItem from '../shared/NavItem';

type Props = {};

class MainMenu extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <ul className="nav nav-tabs nav-lines" role="tablist">
                <NavItem id="mnuProvider" to="/registration/provider">1. Provider Information</NavItem>
                <NavItem id="mnuExperian" to="/registration/experian">2. Experian Questionnaire</NavItem>
                <NavItem id="mnuClinic" to="/registration/clinic">3. Clinic Information </NavItem>
                <NavItem id="mnuContractAgreement" to="/registration/agreement">4. Contract Agreement</NavItem>
                {/* <NavItem id="mnuAttachment" to="/registration/attachment">4. Attachments</NavItem> */}
                <NavItem id="mnuPayment" to="/registration/payment">5. Payment Information</NavItem>
                {/* <NavItem id="mnuSummary" to="/registration/summary">5. Summary</NavItem> */}
            </ul>
        );
    }
}

export default MainMenu;


// WEBPACK FOOTER //
// ./src/components/MainMenu/MainMenu.tsx